document.addEventListener("DOMContentLoaded", function () {
  let wrapper = document.querySelector(".hs-form-frame-wrapper");
  let frame = document.querySelector(".hs-form-frame");
  let loader = document.querySelector(".hs-form-frame-loader");
  if (!wrapper || !frame || !loader) {
    return;
  }

  function hasFormContent() {
    return frame.querySelector('iframe, .hs-form, [class*="hs_"]') !== null;
  }

  if (hasFormContent()) {
    wrapper.classList.add("hs-form-frame-wrapper--is-loaded");
    return;
  }

  const observer = new MutationObserver(function () {
    if (hasFormContent()) {
      wrapper.classList.add("hs-form-frame-wrapper--is-loaded");
      observer.disconnect();
    }
  });

  observer.observe(frame, { childList: true, subtree: true });
});
